/* eslint-disable no-console */
import { varsFromServer } from 'client/javascript/client_side_injection_vars';

const newrelicMock = {
  addPageAction: console.log,
  noticeError: console.error
};

export default varsFromServer.isProd ? window.newrelic : newrelicMock;
